import { render, staticRenderFns } from "./WallboardCardForm.vue?vue&type=template&id=5f714fbc&"
import script from "./WallboardCardForm.vue?vue&type=script&lang=js&"
export * from "./WallboardCardForm.vue?vue&type=script&lang=js&"
import style0 from "./WallboardCardForm.vue?vue&type=style&index=0&id=5f714fbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports